import { Controller } from "@hotwired/stimulus"

// Index des souvenirs : panier multi-sélection persistant (sessionStorage),
// conservé entre les pages paginées et les recherches (turbo frame).
export default class extends Controller {
  static targets = ["card", "checkbox", "quantity", "count", "cartBar", "dialog", "items", "summary"]

  KEY = "philajeune.cart"

  connect() {
    this.cart = this.load()
    this.hydrate()
    this.refresh()
  }

  load() {
    try {
      return JSON.parse(sessionStorage.getItem(this.KEY)) || {}
    } catch {
      return {}
    }
  }

  save() {
    sessionStorage.setItem(this.KEY, JSON.stringify(this.cart))
  }

  // Réapplique l'état coché + quantité aux cartes de la page courante.
  hydrate() {
    this.cardTargets.forEach((card) => {
      const entry = this.cart[card.dataset.id]
      const cb = card.querySelector('[data-souvenirs-target="checkbox"]')
      const qty = card.querySelector('[data-souvenirs-target="quantity"]')
      if (!cb) return
      cb.checked = !!entry
      if (entry && qty) qty.value = entry.q
    })
  }

  // Après un rechargement du turbo frame (recherche / pagination).
  onFrameRender() {
    this.hydrate()
    this.refresh()
  }

  toggle(event) {
    const card = event.target.closest('[data-souvenirs-target="card"]')
    if (!card) return
    const id = card.dataset.id
    if (event.target.checked) {
      this.cart[id] = { t: card.dataset.title, q: this.qtyOf(card) }
    } else {
      delete this.cart[id]
    }
    this.save()
    this.refresh()
  }

  changeQty(event) {
    const card = event.target.closest('[data-souvenirs-target="card"]')
    if (!card) return
    const entry = this.cart[card.dataset.id]
    if (entry) {
      entry.q = this.qtyOf(card)
      this.save()
    }
  }

  qtyOf(card) {
    const input = card.querySelector('[data-souvenirs-target="quantity"]')
    return Math.max(1, parseInt(input?.value || "1", 10))
  }

  refresh() {
    const n = Object.keys(this.cart).length
    if (this.hasCountTarget) this.countTarget.textContent = n
    if (this.hasCartBarTarget) this.cartBarTarget.classList.toggle("hidden", n === 0)
  }

  openCart() {
    const entries = Object.entries(this.cart)
    if (entries.length === 0) return

    this.itemsTarget.innerHTML = ""
    this.summaryTarget.innerHTML = ""

    entries.forEach(([id, { t, q }]) => {
      this.itemsTarget.insertAdjacentHTML("beforeend",
        `<input type="hidden" name="order[items][][souvenir_id]" value="${id}">` +
        `<input type="hidden" name="order[items][][quantity]" value="${q}">`)

      const li = document.createElement("li")
      li.className = "flex items-center justify-between gap-2 px-3 py-2"
      li.textContent = t
      const badge = document.createElement("span")
      badge.className = "text-ink-soft"
      badge.textContent = `× ${q}`
      li.appendChild(badge)
      this.summaryTarget.appendChild(li)
    })

    this.dialogTarget.classList.remove("hidden")
    this.dialogTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
  }

  closeCart(event) {
    event?.preventDefault()
    this.dialogTarget.classList.add("hidden")
    this.dialogTarget.classList.remove("flex")
    document.body.style.overflow = ""
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.closeCart(event)
  }

  // Commande envoyée → on vide le panier persistant.
  clearOnSubmit() {
    this.cart = {}
    this.save()
  }
}
